import Repository from "../../repository";

export default {
    Get: (payload) => Repository.post(`/api/NPLRegions/Get`, payload),
    GetByLevel: (payload) => Repository.post(`/api/NPLRegions/GetByLevel`, payload),
    GetByParentID: (payload) => Repository.post(`/api/NPLRegions/GetByParentID`, payload),
    GetActive: (payload) => Repository.post(`/api/NPLRegions/GetActive`, payload),
    GetById: (payload) => Repository.post(`/api/NPLRegions/GetById`, payload),
    Add: (payload) => Repository.post(`/api/NPLRegions/Add`, payload),
    Edit: (payload) => Repository.post(`/api/NPLRegions/Edit`, payload),
    Delete: (payload) => Repository.post(`/api/NPLRegions/Delete`, payload),
    ChangeStatus: (payload) => Repository.post(`/api/NPLRegions/ChangeStatus`, payload),
}